import Vue from 'vue';
import Company from './App.vue'
import Buefy from 'buefy'

import CompanyDetails from "./components/CompanyDetails.vue"
import Members from "./components/Members.vue"
import PaymentChannels from "./components/PaymentChannels.vue"

Vue.use(Buefy, {
    defaultIconPack: 'fas',
})

Vue.use(CompanyDetails)
Vue.use(Members)
Vue.use(PaymentChannels)

if(document.getElementById("companyApp")){
    new Vue({
        render: h => h(
            Company,
            {
                props:{
                    detailsEndpoint:document.getElementById("companyApp")
                        .getAttribute("details"),
                    countryList:document.getElementById("companyApp")
                        .getAttribute("country-list"),
                    cityList:document.getElementById("companyApp")
                        .getAttribute("city-list"),
                    memberList:document.getElementById("companyApp")
                        .getAttribute("member-list"),
                    invitationList:document.getElementById("companyApp")
                        .getAttribute("invitation-list"),
                    invitationDetail:document.getElementById("companyApp")
                        .getAttribute("invitation-delete"),
                    paymentListUrl:document.getElementById("companyApp")
                        .getAttribute("payment-list-url"),
                    paymentCreateUrl:document.getElementById("companyApp")
                        .getAttribute("payment-create-url"),
                    shipmentListUrl:document.getElementById("companyApp")
                        .getAttribute("shipment-list-url"),
                    shipmentDetailUrl:document.getElementById("companyApp")
                        .getAttribute("shipment-detail-url"),
                    shipmentCreateUrl:document.getElementById("companyApp")
                        .getAttribute("shipment-create-url"),
                    mpAuthUrl: document.getElementById("companyApp")
                        .getAttribute("mp-auth-url"),
                    ppCredDetails: document.getElementById("companyApp")
                        .getAttribute("pp-cred-details"),
                    ppCredCreate: document.getElementById("companyApp")
                        .getAttribute("pp-cred-create"),
                    couponsListCreate: document.getElementById("companyApp")
                        .getAttribute("coupon-list-create"),
                    couponsDetail: document.getElementById("companyApp")
                        .getAttribute("coupon-details"),
                    currencyEndpoint:document.getElementById("companyApp")
                        .getAttribute("currency-endpoint"),
                    isStore:document.getElementById("companyApp")
                        .getAttribute("is-store"),
                    customOrderFieldsUrl:document.getElementById("companyApp")
                        .getAttribute("custom-order-fields"),
                    customOrderFieldsDetailUrl:document.getElementById("companyApp")
                        .getAttribute("custom-order-fields-detail"),
                    customOrderFieldsOptionsUrl:document.getElementById("companyApp")
                        .getAttribute("custom-order-fields-options"),
                    customOrderFieldsOptionsDetailUrl:document.getElementById("companyApp")
                        .getAttribute("custom-order-fields-options-detail")
                }
            }
        )
    }).$mount("#companyApp")
}